import React from 'react';
import {ErrorMessage, Formik} from "formik";
import {Input, message, Modal, Radio} from "antd";
import styles from "./ExportModal.module.css";
import selectItem_styles from "../../LeftToolbar/Select-ItemContainer/Select-ItemContainer.module.css";
import * as Yup from "yup";
import AppService from "../../services/AppService";
import Api from "../../services/APIService";
import {saveAs} from 'file-saver';

import LocalStorageService from "../../../localStorage-service";
import {connect} from "react-redux";

const validation = Yup.string()
    .trim()
    .required('No Schematic name provided');

const ExportSchema = Yup.object().shape({
    schematicDocumentName: Yup.mixed().test('match', 'Schematic document cannot be named as "Draft project"', function () {
        return this.parent.schematicDocumentName !== 'Draft project'
    }).concat(validation)
});
const showMessage = (typeofMessage, content) => {
    message[typeofMessage](content)
};


class ExportModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            schematic_list: [],
            checkedRadioBtnValue: 'Cloud'
        }
    }

    exportJsonToCloud = (newName) => {
        const {graph, onClose} = this.props;

        const json = graph.exportJson();
        const schematic_type_id = LocalStorageService.getSchematicTypeId();
        this.setState({confirmLoading: true});
        Api.saveSchematic({json, document_name: newName, schematic_type_id}).then(res => {
            const previousSchematicId = LocalStorageService.getSchematicId();
            /**
             * Save to the new schematic
             */

            if (previousSchematicId !== res.id) {
                LocalStorageService.setSchematic(res);
            }
            showMessage('success', 'Saved');
            graph.saveHistorySnapshot();
            this.setState({confirmLoading: false});
            onClose();
        }).catch(() => {
            this.setState({confirmLoading: false});
            onClose();
        })
    };

    exportJsonToDevice = (name) => {
        const {graph} = this.props;
        const json = graph.exportJson();
        try {
            this.downloadObjectAsJson(json, name)
        } catch (e) {
            showMessage('error', e.message);
        }
    }


    wrapperSaveJson = (values, props) => {
        const {checkedRadioBtnValue} = this.state;
        switch (checkedRadioBtnValue) {
            case'Cloud': {
                this.exportJsonToCloud(values.schematicDocumentName);
                break;
            }
            case 'Computer': {
                this.exportJsonToDevice(values.schematicDocumentName);
                break;
            }
        }
    }
    handleRadioButtons = e => this.setState({checkedRadioBtnValue: e.target.value});

    get createRadioGroup() {
        const {checkedRadioBtnValue} = this.state
        return (
            <div className={styles.radionBtn_container}>
                <Radio.Group onChange={this.handleRadioButtons} value={checkedRadioBtnValue}>
                    <Radio value='Cloud'>Cloud</Radio>
                    <Radio value='Computer'>Computer</Radio>
                </Radio.Group>
            </div>
        )
    }

    get value() {
        const {schematicDocument} = this.props;
        if (schematicDocument) {
            return schematicDocument.document_name === 'Draft project' ? '' : schematicDocument.document_name
        }
        return ''
    }

    downloadObjectAsJson = (exportObj, exportName) => {
        const {graph, onClose} = this.props;
        const blob = new Blob([JSON.stringify(exportObj)], {type: "text/json;charset=utf-8"});
        saveAs(blob, `${exportName}.json`);
        graph.refreshHistory();
        onClose();
    }
    handleCancel = (errors, resetForm) => {
        const {onClose} = this.props;
        if (errors.schematicDocumentName) {
            resetForm()
        }
        onClose();
    }


    render() {
        const {visible} = this.props;
        const {confirmLoading} = this.state;
        return (
            <Formik
                enableReinitialize={true}
                initialValues={{schematicDocumentName: this.value}}
                validationSchema={ExportSchema}
                onSubmit={this.wrapperSaveJson}
            >
                {({
                      values,
                      handleChange,
                      handleBlur,
                      resetForm,
                      handleSubmit,
                      errors
                  }) => {
                    return <Modal
                        title='Save to'
                        visible={visible}
                        confirmLoading={confirmLoading}
                        okButtonProps={{htmlType: 'submit'}}
                        onOk={handleSubmit}
                        onCancel={() => this.handleCancel(errors, resetForm)}
                    >
                        <div>
                            <label htmlFor="input_document_name">Schematic name<span
                                className={styles.mark_required}>*</span></label>
                        </div>
                        <Input size="medium"
                               name='schematicDocumentName'
                               onBlur={handleBlur}
                               onChange={handleChange}
                               id='input_document_name'
                               value={values.schematicDocumentName}
                               className={selectItem_styles.pinout_table_form__input}
                        />
                        <ErrorMessage name='schematicDocumentName'>{msg => <p
                            className={styles.error_style}>{msg}</p>}</ErrorMessage>
                        {this.createRadioGroup}
                    </Modal>
                }}
            </Formik>
        )
    }
}

function mapStateToProps({schematicReducers: {schematicDocument, graph}}) {
    return {
        graph: graph.value,
        schematicDocument,
    }
}

export default connect(mapStateToProps, null)(ExportModal);